export const newAdvisorWizardStep = Object.freeze({
    label: 'New Step',
    snippets: [],
    formData: { isActive: false, overwriteSnippets: false, snippets: [] },
    searchData: { isActive: false, overwriteSnippets: false, snippets: [] },
    freeTextData: { isActive: false, overwriteSnippets: false, snippets: [] },
});
//# sourceMappingURL=consts.js.map